import { render, staticRenderFns } from "./ResourceKanbanPage.vue?vue&type=template&id=3751e4c0&scoped=true"
import script from "./ResourceKanbanPage.vue?vue&type=script&lang=js"
export * from "./ResourceKanbanPage.vue?vue&type=script&lang=js"
import style0 from "./ResourceKanbanPage.vue?vue&type=style&index=0&id=3751e4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751e4c0",
  null
  
)

export default component.exports